export default __webpack_public_path__ + "static/media/portfolio-2.fc3013b0.jpg";